import { environment as types } from 'pursuit/store/storeTypes';

const initialState = {
    ding: 'dong',
    envs: {
        // pp: {
        //     name: 'PP',
        //     versions: {},
        //     pushState: false,
        // },
        // pp2: {
        //     name: 'PP2',
        //     versions: {},
        //     pushState: false,
        // },
        // qa1: {
        //     name: 'QA1',
        //     versions: {},
        //     pushState: false,
        // },
        // qa2: {
        //     name: 'QA2',
        //     versions: {},
        //     pushState: false,
        // },
        // ss: {
        //     name: 'SS',
        //     versions: {},
        //     pushState: false,
        // }
    },
    pushes: {}
};

const environmentReducer = function(state = initialState, action) {
    switch(action.type) {
        case types.UPDATE_ENVS:
            return Object.assign({}, state, {
                'envs': action.data.envs,
            });
        // case types.UPDATE_USER_DATA:
        //     return Object.assign({}, state, {
        //     });
        // case types.CLEAR_USER_DATA:
        //     return Object.assign({}, state);
    }

    return state;
}

export default environmentReducer;
